import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Category } from 'src/app/models/category/categoryListing.modal';
import { ProductModel, ProductResponseModel, ProductSort } from 'src/app/models/Home/home-list.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { AddProductModel } from 'src/app/models/product/addProduct.model';
import { GetProductAssetModel } from 'src/app/models/product/productAssets.modal';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { IsjustAddedService } from 'src/app/services/isjust-added.service';
import { ProductService } from 'src/app/services/product.service';
import { ProductNameComponent } from '../product-name/product-name.component';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
  homeContentList: ProductSort = new ProductSort();
  homeProductResponseModel: ProductResponseModel = new ProductResponseModel();
  categoryId: Category = new Category();
  addProductModel: AddProductModel = new AddProductModel();
  name: any;
  pagingModel: PagingModel = new PagingModel();
  totalPages: number;
  pageNumber: number = 1;
  searchValue: string = "";
  Loader: boolean = false;
  imageLoader: boolean = false;
  uploadingFilesCount: number = 0;
  productimage: ProductModel = new ProductModel;
  productAssets: GetProductAssetModel = new GetProductAssetModel;
  productName: string;
  localStorage:LocalstorageService;
  IsJustAdded

  constructor(private homePageService: HomePageService, private _isJustAddedService:IsjustAddedService, private router: Router, private _localStorage:LocalstorageService, private modalService: NgbModal) {
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }

    this.localStorage = _localStorage;
  }
  receivename($event: string) {
    this.name = $event
  }
  ngOnInit() {
    this.productName = localStorage.getItem('searchBar');
    if (this.productName == "null" || this.productName == "undefined") {
      this.productName = null;
    }
    this.HomeProductList();
    this.homePageService.getCategoryId.subscribe((categoryId: string) => {
      this.homeContentList.CategoryIds = categoryId;
      if (this.homeContentList.CategoryIds != "" && null) {
      this.HomeProductList();
      }
    });   
    this.homePageService.getProductType.subscribe((product: any) => {
      this.homeContentList.ProductType = product;
      this.HomeProductList();
    });
    this.homePageService.getResetFilters.subscribe((action : string) =>{
      if (action == 'reset') {
        this.homeContentList.PageNumber = 1;
        this.homeContentList.PageSize = 10;
        this.totalPages = 1;
        this.homeContentList.ProductType = "";
        this.HomeProductList();
      }
    });
    this.homePageService.getSearchFilters.subscribe((search : string) =>{
        this.homeContentList.PageNumber = 1;
        this.homeContentList.PageSize = 10;
        this.HomeProductList();
    });
  }

  loadPage(pagingModel: PagingModel) {
    this.homeContentList.PageNumber = pagingModel.pageNumber;
    this.homeContentList.PageSize = pagingModel.pageSize;
    this.HomeProductList();
  }

  HomeProductList() {
    this.Loader = true;
    this.homeContentList.CategoryIds;
    this.homeContentList.IsJustAdded = this._isJustAddedService.isJustAdded;    
    this.homeContentList.ProductType;
    this.productName = localStorage.getItem('searchBar');
    this.homeContentList.Keyword = this.productName != null && this.productName != '' ? this.productName : '';
    localStorage.removeItem('searchBar');
    this.homePageService.ProductContentList(this.homeContentList)
      .subscribe((response) => {
        this.Loader = false;
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.homeProductResponseModel.ProductSort = responseBody.responseData;
          this.homeProductResponseModel.ProductSort.forEach((element, index) => {
            this.homeProductResponseModel.ProductSort[index].imageLoader = true;
            this.homePageService.ProductImageList(element.productId)
              .subscribe((response) => {
                let responseimage = JSON.parse(response._body)
                if (responseimage.isSuccess) {
                  if(typeof this.homeProductResponseModel.ProductSort[index] != 'undefined') {
                    this.homeProductResponseModel.ProductSort[index].productImage = responseimage.responseData;
                    this.homeProductResponseModel.ProductSort[index].imageLoader = false;
                  }
                } (err) => {
                }
              })
          });
          this.homeProductResponseModel.TotalPages = responseBody.totalPages;
          this.totalPages = this.homeProductResponseModel.TotalPages == undefined ? 0 : this.homeProductResponseModel.TotalPages;
        } (err) => {
          this.Loader = false;
        }
      })
  }

  uploadImage(item) {
       const url = this.router.serializeUrl(
       this.router.createUrlTree(['/product-page/' + item.productId]));
       window.open('#' + url, '_blank');
  }
  orderConfirm(item) {
    if (this.localStorage.getToken()) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/order-confirm/' + item.productId]));
        window.open('#' + url, '_blank');
    } else {
      this.router.navigate(['/login'],{ queryParams: { return: window.location.origin+'/#/product-page/' + item.productId } });
    }
  }

  newProductEvent(searchKeyword) {
    if (searchKeyword != null && searchKeyword != undefined && searchKeyword != '') {
      this.homeContentList.Keyword = searchKeyword;
      this.homeContentList.PageNumber = 1;
      this.HomeProductList();
    }
  }

  requestQuote(item) {
    if (this.localStorage.getToken()) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/request-quote/' + item.productId]));
        window.open('#' + url, '_blank');
    } else {
      this.router.navigate(['/login'],{ queryParams: { return: window.location.origin+'/#/product-page/' + item.productId } });
    }
  }

  shopProductName(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "sm";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(ProductNameComponent, modalConfig);
    modalRef.componentInstance.productTitle = item.productTitle;
  }

}
